import { render } from "./layout.vue?vue&type=template&id=1282e9ef&scoped=true"
import script from "./layout.vue?vue&type=script&lang=js"
export * from "./layout.vue?vue&type=script&lang=js"

import "./layout.vue?vue&type=style&index=0&id=1282e9ef&lang=scss"
import "./layout.vue?vue&type=style&index=1&id=1282e9ef&scoped=true&lang=css"

import exportComponent from "/var/www/app/app-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1282e9ef"]])

export default __exports__